import React from "react";
import PropTypes from "prop-types";
import CircularProgress from "@mui/material/CircularProgress";
import MDButton from "components/MDButton";

const SubmitButton = ({ loading, disabled, children, startIcon, ...rest }) => (
  <MDButton
    variant="gradient"
    color="info"
    disabled={disabled || loading}
    startIcon={loading ? <CircularProgress size={20} color="inherit" /> : startIcon}
    {...rest}
  >
    {children}
  </MDButton>
);

SubmitButton.propTypes = {
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
  children: PropTypes.node.isRequired,
  startIcon: PropTypes.node,
};

SubmitButton.defaultProps = {
  loading: false,
  disabled: false,
  startIcon: null,
};

export default SubmitButton;
